import { Box, Paper, Typography } from '@mui/material';
import { CustomersView } from './CustomerView';
import { CustomLoadingButton } from 'components/Buttons/CustomLoadingButton/CustomLoadingButton';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import useAppTheme from 'hooks/useAppTheme';
import { ThemePalette } from 'mui.theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const CustomerSettingView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const handleBackClick = () => {
    navigate('/customer-selection');
  };
  return (
    <Box display={'flex'} flexDirection={'column'} p={2}>
      <Paper
        sx={{
          display: 'flex',
          gap: 5,
          p: 2,
          alignItems: 'center',
          backgroundColor: enableDarkTheme
            ? palette.toolBarBackground
            : palette.toolBarBackground,
        }}
      >
        <CustomLoadingButton
          startIcon={<ArrowBack />}
          onClick={handleBackClick}
        >
          {t('cdp_button_back')}
        </CustomLoadingButton>
        <Typography
          sx={{
            color: palette.textPrimary,
            fontSize: '1.4rem',
          }}
        >
          {t('customer_settings')}
        </Typography>
      </Paper>
      <CustomersView />
    </Box>
  );
};
